import { SearchOutlined } from '@ant-design/icons';
import { Box, IconButton, Modal } from '@mui/material';
import { Button, Col, Input, Row, Space, Spin, Table, message } from 'antd';
import { useRef, useState } from 'react';
import Highlighter from 'react-highlight-words';
import SearchIcon from "@mui/icons-material/Search";
import PictureAsPdfIcon from '@mui/icons-material/PictureAsPdf';
import { findAllOrderDetailByOrderAndRefAndColorEvent, pdfViewListByClientEvent, pdfViewListByOrderEvent, pdfViewListLiveByClientEvent, excelViewListLiveByClientEvent, excelViewListByClientEvent } from '../../_events/order_list_view/find.event';
import { displayPDFOrderIdEvent } from '../../_events/orders/order_box.event';
import { downloadExcelFile } from '../../_utils/download_file.util';

const style = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: '80%',
    bgcolor: 'background.paper',
    border: '2px solid #fff',
    borderRadius: '20px',
    boxShadow: 24,
    p: 4,
};

export default function OrderInfo({ hook, type = 'all' }) {

    const [searchText, setSearchText] = useState('');
    const [searchedColumn, setSearchedColumn] = useState('');
    const searchInput = useRef(null);
    const [ ordersDetail, setOrdersDetail ] = useState([]);
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [openPDF, setOpenPDF] = useState(false);
    const [pdf, setPDF] = useState(null);
    const [ loading, setLoading ] = useState(false);

    const handleCancel = () => {
        setOrdersDetail([]);
        setIsModalOpen(false);
    };

    const handleSearch = (selectedKeys, confirm, dataIndex) => {
        confirm();
        setSearchText(selectedKeys[0]);
        setSearchedColumn(dataIndex);
    };

    const handleReset = (clearFilters) => {
        clearFilters();
        setSearchText('');
    };

    const handleClosePDF = () => {
        setOpenPDF(false);
        setPDF(null);
      };

    const displayPDF = (order) => {
        if(! order) message.error('No hay orden');
        else {
            displayPDFOrderIdEvent(order)
            .then(data => {
                setPDF(data.data.toAproveJSON);
                setOpenPDF(true);     
            })
            .catch(err => {
                message.error(err.message);
            });
        }    
    }

    const displayPDFGroup = (order) => {
        if(! order) message.error('No hay orden');
        else {
            pdfViewListByOrderEvent(order)
            .then(data => {
                setPDF(data.data.bytes);
                setOpenPDF(true);     
            })
            .catch(err => {
                message.error(err.message);
            });
        }    
    }

    const displayAllPDFGroup = (client) => {
        if(! client) message.error('No hay Cliente');
        else if(type === 'live'){
            setLoading(true);
            pdfViewListLiveByClientEvent(client)
            .then(data => {
                setPDF(data.data.bytes);
                setOpenPDF(true);    
                setLoading(false); 
            })
            .catch(err => {
                message.error(err.message);
                setLoading(false);
            });
        } else if(type === 'all'){
            setLoading(true);
            pdfViewListByClientEvent(client)
            .then(data => {
                setPDF(data.data.bytes);
                setOpenPDF(true);    
                setLoading(false); 
            })
            .catch(err => {
                message.error(err.message);
                setLoading(false);
            });
        } else {
            message.error('Error en typo de PDF');
        }
    }

    const displayAllExcelGroup = (client) => {
        if(! client) message.error('No hay Cliente');
        else if(type === 'live'){
            setLoading(true);
            excelViewListLiveByClientEvent(client)
            .then(data => {
                downloadExcelFile(data.data.bytes, 'LISTADO_PEDIDOS');   
                setLoading(false); 
            })
            .catch(err => {
                message.error(err.message);
                setLoading(false);
            });
        } else if(type === 'all'){
            setLoading(true);
            excelViewListByClientEvent(client)
            .then(data => {
                downloadExcelFile(data.data.bytes, 'LISTADO_PEDIDOS');
                setLoading(false); 
            })
            .catch(err => {
                message.error(err.message);
                setLoading(false);
            });
        } else {
            message.error('Error en typo de PDF');
        }
    }

    const getColumnSearchProps = (dataIndex) => ({
        filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters, close }) => (
        <div
            style={{
                padding: 8,
            }}
            onKeyDown={(e) => e.stopPropagation()}
        >
            <Input
            ref={searchInput}
            placeholder={`Search ${dataIndex}`}
            value={selectedKeys[0]}
            onChange={(e) => setSelectedKeys(e.target.value ? [e.target.value] : [])}
            onPressEnter={() => handleSearch(selectedKeys, confirm, dataIndex)}
            style={{
                marginBottom: 8,
                display: 'block',
            }}
            />
            <Space>
            <div style={{ display: 'flex', flexDirection: 'row' }}>
            <Button
                type="primary"
                onClick={() => handleSearch(selectedKeys, confirm, dataIndex)}
                icon={<SearchOutlined />}
                size="small"
                style={{
                width: 90,
                }}
            >
                Search
            </Button>
            <Button
                onClick={() => clearFilters && handleReset(clearFilters)}
                size="small"
                style={{
                width: 90,
                }}
            >
                Reset
            </Button>
            {
                /**
                 
                <Button
                type="link"
                size="small"
                onClick={() => {
                confirm({
                    closeDropdown: false,
                });
                setSearchText(selectedKeys[0]);
                setSearchedColumn(dataIndex);
                }}
            >
                Filter
            </Button>
            <Button
                type="link"
                size="small"
                onClick={() => {
                close();
                }}
            >
                close
            </Button>
                 */
            }
            </div>
            </Space>
        </div>
        ),
        filterIcon: (filtered) => (
        <SearchOutlined
            style={{
            color: filtered ? '#1677ff' : undefined,
            }}
        />
        ),
        onFilter: (value, record) =>
        record[dataIndex].toString().toLowerCase().includes(value.toLowerCase()),
        onFilterDropdownOpenChange: (visible) => {
        if (visible) {
            setTimeout(() => searchInput.current?.select(), 100);
        }
        },
        render: (text) =>
        searchedColumn === dataIndex ? (
            <Highlighter
            highlightStyle={{
                backgroundColor: '#ffc069',
                padding: 0,
            }}
            searchWords={[searchText]}
            autoEscape
            textToHighlight={text ? text.toString() : ''}
            />
        ) : (
            text
        ),
    });

    const loadOrderDetail = (order, ref, color) => {
        findAllOrderDetailByOrderAndRefAndColorEvent(order, ref, color)
        .then(json => {
            setOrdersDetail(json.list);
            setIsModalOpen(true);
        })
        .catch(err => {
            message.error(err.message);
        });
    }

    const columns = [
        {
            title: '',
            dataIndex: 'deleted',
            key: 'deleted',
            width: '5%',
            render: (text, param, index) => {
                return(
                    <div style={{ display: 'flex', flexDirection: 'column' }}>
                        <span style={{ fontSize: '0.5em', color: param.order_deleted ? 'red': 'blue' }}>{ param.order_deleted ? 'PEDIDO ELIMINADO' : 'PEDIDO' }</span>
                        <span style={{ fontSize: '0.5em', color: param.deleted ? 'red': 'blue' }}>{ param.deleted ? 'DETALLE ELIMINADO' : 'DETALLE' }</span>
                    </div>
                );
            }
        },
        {
            title: '',
            dataIndex: 'deleted',
            key: 'deleted',
            width: '3%',
            render: (text, param, index) => {
                return(
                    <IconButton
                        style={{ marginRight: '10px' }}
                        color='primary'
                        aria-label='pdf'
                        onClick={() => {
                            displayPDF(param.order_uuid);
                        }}
                    >
                        <PictureAsPdfIcon />
                    </IconButton>
                );
            }
        },
        {
            title: 'Pedido',
            dataIndex: 'order',
            key: 'order',
            width: '13%',
            ...getColumnSearchProps('order'),
        },
        {
            title: 'OC',
            dataIndex: 'purchase_order',
            key: 'purchase_order',
            width: '13%',
            ...getColumnSearchProps('purchase_order'),
        },
        {
            title: 'Fecha pedido',
            dataIndex: 'date_created',
            key: 'date_created',
            width: '10%',
            ...getColumnSearchProps('date_created'),
        },
        {
            title: 'Fecha entrega',
            dataIndex: 'date_delivery',
            key: 'date_delivery',
            width: '10%',
            ...getColumnSearchProps('date_delivery'),
        },
        {
            title: 'Producto',
            dataIndex: 'ref',
            key: 'ref',
            width: '10%',
            ...getColumnSearchProps('ref'),
        },
        {
            title: 'Color',
            dataIndex: 'color',
            key: 'color',
            width: '5%',
            ...getColumnSearchProps('color'),
        },
        {
            title: 'Cantidad',
            dataIndex: 'quantity',
            key: 'quantity',
            width: '5%',
            ...getColumnSearchProps('quantity'),
        },
        {
            title: 'Tipo',
            dataIndex: 'type',
            key: 'type',
            width: '5%',
            ...getColumnSearchProps('type'),
        },
        {
            title: 'Pendiente',
            dataIndex: 'pend',
            key: 'pend',
            width: '5%',
            ...getColumnSearchProps('pend'),
        },
        {
            title: 'Reservado',
            dataIndex: 'reser',
            key: 'reser',
            width: '5%',
            ...getColumnSearchProps('reser'),
        },
        {
            title: 'Despachado',
            dataIndex: 'despa',
            key: 'despa',
            width: '5%',
            ...getColumnSearchProps('despa'),
        },
        {
            title: '',
            dataIndex: 'order',
            key: 'order',
            width: '3%',
            render: (text, param, index) => {
                return(
                    <div style={{ display: 'flex', flexDirection: 'row' }}>
                        <IconButton 
                            size='small' 
                            color="primary"  
                            onClick={() => { 
                                loadOrderDetail(param.order, param.ref, param.color);
                            }}>
                            <SearchIcon /> 
                        </IconButton>
                        <IconButton
                            style={{ marginRight: '10px' }}
                            color='primary'
                            aria-label='pdf'
                            onClick={() => {
                                displayPDFGroup(param.order_uuid);
                            }}
                        >
                            <PictureAsPdfIcon />
                        </IconButton>
                    </div>
                );
            }
        },
    ];


    return(
        <Row>
            <Col xs={2} lg={2}>
            </Col>
            <Col xs={22} lg={22}>
            <Modal
                open={isModalOpen}
                onClose={handleCancel}
                aria-labelledby="modal-modal-title"
                aria-describedby="modal-modal-description"
            >
                <Box sx={style}>
                    <Row>
                        <Col lg={24} xs={24}>
                            <div style={{ margin: '20px 0', fontWeight: 'bold' }}>{hook.data?.client_name}</div>
                        </Col>
                        <Col lg={24} xs={24}>
                            <table style={{ width: '100%' }}>
                                <tr>
                                    <th style={{ width: '5%', fontSize: '0.8em', border: '1px solid #ccc' }}>
                                        Producto
                                    </th>
                                    <th style={{ width: '5%', fontSize: '0.8em', border: '1px solid #ccc' }}>
                                        Color
                                    </th>
                                    <th style={{ width: '5%', fontSize: '0.8em', border: '1px solid #ccc' }}>
                                        Cantidad
                                    </th>
                                    <th style={{ width: '5%', fontSize: '0.8em', border: '1px solid #ccc' }}>
                                        Medida
                                    </th>
                                    <th style={{ width: '5%', fontSize: '0.8em', border: '1px solid #ccc' }}>
                                        Proceso
                                    </th>
                                    <th style={{ width: '10%', fontSize: '0.8em', border: '1px solid #ccc' }}>
                                        Ingreso Crudo
                                    </th>
                                    <th style={{ width: '10%', fontSize: '0.8em', border: '1px solid #ccc' }}>
                                        Ingreso Tintoreria
                                    </th>
                                    <th style={{ width: '10%', fontSize: '0.8em', border: '1px solid #ccc' }}>
                                        Ingreso Enrollado
                                    </th>
                                    <th style={{ width: '10%', fontSize: '0.8em', border: '1px solid #ccc' }}>
                                        Empacado
                                    </th>
                                    <th style={{ width: '10%', fontSize: '0.8em', border: '1px solid #ccc' }}>
                                        Despachado
                                    </th>
                                </tr>
                                {
                                    ordersDetail.map((od, key) => {
                                        console.log(od);
                                        return(
                                            <tr key={`od_detail_${key}`}>
                                                <td style={{ width: '5%', fontSize: '0.8em', border: '1px solid #ccc' }}>
                                                    {od.productPrice?.product?.ref}
                                                </td>
                                                <td style={{ width: '5%', fontSize: '0.8em', border: '1px solid #ccc' }}>
                                                    {od.color?.cod}
                                                </td>
                                                <td style={{ width: '5%', fontSize: '0.8em', border: '1px solid #ccc' }}>
                                                    {od.quantity}
                                                </td>
                                                <td style={{ width: '5%', fontSize: '0.8em', border: '1px solid #ccc' }}>
                                                    {od.type_quantity}
                                                </td>
                                                <td style={{ width: '5%', fontSize: '0.8em', border: '1px solid #ccc' }}>
                                                    {od.cod_process}
                                                </td>
                                                <td style={{ width: '10%', fontSize: '0.8em', border: '1px solid #ccc' }}>
                                                    {od.fecha_crudo ? od.fecha_crudo.split("T")[0] : '---'}
                                                </td>
                                                <td style={{ width: '10%', fontSize: '0.8em', border: '1px solid #ccc' }}>
                                                    {od.fecha_tintoreria ? od.fecha_tintoreria.split("T")[0] : '---'}
                                                </td>
                                                <td style={{ width: '10%', fontSize: '0.8em', border: '1px solid #ccc' }}>
                                                    {od.fecha_enrollado ? od.fecha_enrollado.split("T")[0] : '---'}
                                                </td>
                                                <td style={{ width: '10%', fontSize: '0.8em', border: '1px solid #ccc' }}>
                                                    {od.fecha_despachos ? od.fecha_despachos.split("T")[0] : '---'}
                                                </td>
                                                <td style={{ width: '10%', fontSize: '0.8em', border: '1px solid #ccc' }}>
                                                    {od.fecha_remission ? od.fecha_remission.split("T")[0] : '---'}
                                                </td>
                                            </tr>
                                        );
                                    })
                                }
                            </table>
                        </Col>
                    </Row>
                </Box>
            </Modal>
            <Modal
                open={openPDF}
                onClose={handleClosePDF}
                aria-labelledby="modal-modal-title"
                aria-describedby="modal-modal-description"
            >
                <Box sx={style}>
                    <Row>
                    {
                    !pdf ? <>Cargando...</> :
                    <Col xs={24} lg={24}>
                        <object width="100%" height="600px" 
                        data={`data:application/pdf;base64,${pdf}`} 
                        type="application/pdf" className="internal"
                        >
                        <embed 
                            src={`data:application/pdf;base64,${pdf}`}
                            type="application/pdf"
                        />
                        </object>
                    </Col>
                    }
                    </Row>
                </Box>
            </Modal>   
                <div style={{ display: 'flex', flexDirection: 'row', height: '100%' }}>
                    <div style={{ margin: '20px 10px', fontWeight: 'bold', height: '100%', display: 'flex', flexDirection: 'column', alignItems: 'center' }}>{hook.data?.client_name}</div>
                    <div style={{ margin: '0 10px' }}>
                        {
                            loading ? 
                            <Spin />
                            :
                            <Button
                                type='primary'
                                onClick={() => {
                                    displayAllPDFGroup(hook.data.client_uuid);
                                }}
                            >
                                Descargar PDF
                            </Button>
                        }
                    </div>
                    <div style={{ margin: '0 10px' }}>
                        {
                            loading ? 
                            <Spin />
                            :
                            <Button
                                type='primary'
                                onClick={() => {
                                    displayAllExcelGroup(hook.data.client_uuid);
                                }}
                            >
                                Descargar Excel
                            </Button>
                        }
                    </div>
                </div>
            </Col>
            <Col xs={24} lg={24}>
                <Table columns={columns} dataSource={hook.data?.detailsGroup} size='small' pagination={true} />
            </Col>         
        </Row>
    );
};